import {useEffect, useState} from 'react';
import {useTokenValue} from '@sail/engine';
import {tokens} from '@sail/tokens/deprecated';
import {mediaQueryManager} from './MediaQueryManager';

const useClientMatchMedia = (query: string) => {
  const [matches, setMatches] = useState<boolean>(
    () => mediaQueryManager.matchMedia(query).matches,
  );

  useEffect(() => {
    const supportsMatchMedia = typeof window?.matchMedia === 'function';

    if (!supportsMatchMedia) {
      return;
    }

    const unsubscribe = mediaQueryManager.addQueryListener(
      query,
      ({matches}) => {
        setMatches(matches);
      },
    );

    return unsubscribe;
  }, [query]);

  return matches;
};

const useMediaSmallScreen = (): boolean => {
  const viewport = useTokenValue(tokens.viewport.small);

  return useClientMatchMedia(`(max-width: calc(${viewport} - 0.1px))`);
};

export const useMediaAnyCoarsePointer = (): boolean => {
  return useClientMatchMedia('(any-pointer: coarse)');
};

export function useMediaSmallScreenAndTouch() {
  const isSmallScreen = useMediaSmallScreen();
  const isAnyCoarsePointer = useMediaAnyCoarsePointer();

  return isSmallScreen && isAnyCoarsePointer;
}

/** @deprecated @ignore Use useMediaSmallScreenAndTouch instead */
export const useIsMobileAndTouchCheck = useMediaSmallScreenAndTouch;
